export var TabStyle = function (selected) {
    return (selected
        ? "text-white bg-gradient-to-r from-main-gradient-from to-main-gradient-to hover:text-black-200"
        : "text-black-600 bg-black-1000 hover:bg-black-800 hover:text-white") +
        " font-N7 rounded-[10px] px-[32px] py-[8px]";
};
